import React, { useEffect, useRef, useState } from 'react';
import { handleTrack } from '../../../../../utils/tracker';

interface ITAB_PROPS {
  tabs: Array<{
    id: string;
    title: string;
    render: () => JSX.Element;
  }>;
  defaultSelectedIndex?: number;
  trackLabel: string;
  onClickHandler?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

export function TabBarWithRender({
  tabs,
  defaultSelectedIndex = 0,
  trackLabel,
  onClickHandler,
}: ITAB_PROPS): JSX.Element {
  const [activeTab, setActiveTab] = useState(defaultSelectedIndex);
  const [tabEffectWidth, setEffectWidth] = useState(100);
  const [tabEffectLeftOffeset, setTabEffectLeftOffset] = useState(0);
  const tabsRef = useRef<HTMLDivElement[]>([]);

  const setTabPosition = () => {
    const currentTab = tabsRef.current[activeTab] as unknown as HTMLDivElement;
    if (currentTab) {
      setTabEffectLeftOffset(currentTab?.offsetLeft ?? 0);
      setEffectWidth(currentTab?.clientWidth ?? 0);
    }
  };

  useEffect(() => {
    setActiveTab(defaultSelectedIndex);
  }, [defaultSelectedIndex]);

  useEffect(() => {
    setTabPosition();
    window.addEventListener('resize', setTabPosition);

    return () => window.removeEventListener('resize', setTabPosition);
  }, [activeTab]);

  return (
    <>
      <div className="wg-container sm:overflow-auto sm:mb-8">
        <div className="mx-auto sm:w-fit w-3/4 bg-[#F5F6F7] rounded-3xl mb-12  md:w-full sm:mb-0">
          <div className="grid grid-flow-col text-center text-gray-500 bg-gray-100 rounded-full relative tabs ">
            {tabs.map((tab, index) => {
              const active = activeTab === index;

              return (
                <React.Fragment key={tab.id}>
                  <div
                    id={tab.id}
                    role="tab"
                    aria-selected={active ? 'true' : 'false'}
                    tabIndex={index}
                    ref={(el) => {
                      if (el) tabsRef.current[index] = el;
                    }}
                    className={`cursor-pointer px-8 py-3 md:px-7 sm:px-5  flex justify-center relative z-10 rounded-[32px] font-semibold text-center whitespace-nowrap text-base ${
                      active ? 'text-blue-350' : 'text-[#929FB0]'
                    }`}
                    onClick={(e) => {
                      handleTrack({
                        label: `${trackLabel}_horizonal_tab`,
                        obj: e.target,
                      });
                      onClickHandler && onClickHandler(e);
                      setActiveTab(index);
                    }}
                  >
                    {tab.title}
                  </div>

                  <span
                    className="absolute bottom-0 top-0 block py-3 bg-white rounded-[32px] border border-blue-350 transition-all duration-500 "
                    style={{
                      left: tabEffectLeftOffeset,
                      width: tabEffectWidth,
                    }}
                  />
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
      <div>{tabs[activeTab]?.render()}</div>
    </>
  );
}
